(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ltp-frame-swatch-options"] && !Shopify.designMode) return;
  try {
    document.documentElement.dataset.ltpFrameInput = 'pointer';

  document.addEventListener('keydown', (event) => {
    if (event.isTrusted) document.documentElement.dataset.ltpFrameInput = 'keyboard';
  }, true);

  document.addEventListener('pointerdown', (event) => {
    if (event.isTrusted) document.documentElement.dataset.ltpFrameInput = 'pointer';
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ltp-pdp-review-signal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ltp-review-signal')) {
    customElements.define('ltp-review-signal', class extends HTMLElement {
      connectedCallback() {
        const update = () => {
          const source = document.querySelector('#ltp-pdp-reviews [data-widget="reviews-grid"][data-shop-review-count]');
          const value = source?.getAttribute('data-shop-review-count')?.trim();
          if (!value || !/^\d+$/.test(value)) return;
          const label = `${value} ${Number(value) === 1 ? this.dataset.one : this.dataset.many}`;
          const text = this.querySelector('[data-review-count]');
          if (text && text.textContent !== label) text.textContent = label;
          const link = this.querySelector('a');
          if (link) link.hidden = false;
        };
        this.observer = new MutationObserver(update);
        this.observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-shop-review-count'] });
        update();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
